import React from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import "../_tabs-nav.scss";

export type AvailableSecurityTabs = "ChangePassword" | "ChangeAccessCode" | "ChangeTwoFactor";

type UserProfileSecurityDialogTabsProps = {
    activeTab: AvailableSecurityTabs;
    handleChangeTab: (tabName: AvailableSecurityTabs) => void;
};

export const UserProfileSecurityDialogTabs = (props: UserProfileSecurityDialogTabsProps) => {
    const { activeTab, handleChangeTab } = props;
    const { t } = useTranslation();

    return (
        <div className="tabs-nav">
            <div
                className={cx([
                    "tabs-nav__row",
                    {
                        "tabs-nav__row--active": activeTab === "ChangePassword",
                    },
                ])}
            >
                <button className="tabs-nav__link" type="button" onClick={() => handleChangeTab("ChangePassword")}>
                    <span className="paragraph paragraph--no-spacing">
                        {t("Gui.Common.UserProfileSecurityDialog.ChangePasswordTabName")}
                    </span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
            <div
                className={cx([
                    "tabs-nav__row",
                    {
                        "tabs-nav__row--active": activeTab === "ChangeAccessCode",
                    },
                ])}
            >
                <button className="tabs-nav__link" type="button" onClick={() => handleChangeTab("ChangeAccessCode")}>
                    <span className="paragraph paragraph--no-spacing">
                        {t("Gui.Common.UserProfileSecurityDialog.ChangeAccessCodeTabName")}
                    </span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
            <div
                className={cx([
                    "tabs-nav__row",
                    {
                        "tabs-nav__row--active": activeTab === "ChangeTwoFactor",
                    },
                ])}
            >
                <button className="tabs-nav__link" type="button" onClick={() => handleChangeTab("ChangeTwoFactor")}>
                    <span className="paragraph paragraph--no-spacing">
                        {t("Gui.Common.UserProfileSecurityDialog.ChangeTwoFactorTabName")}
                    </span>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
};
